import { createTheme, MantineColorsTuple } from '@mantine/core';

// Define custom brand colors based on existing CSS variables
const brand: MantineColorsTuple = [
  '#ccdbdc', // --color-brand-lightest
  '#9ad1d4', // --color-brand-light  
  '#80ced7', // --color-brand-medium
  '#007ea7', // --color-brand-dark
  '#003249', // --color-brand-darkest
  '#003249',
  '#003249',
  '#003249',
  '#003249',
  '#003249'
];

export const mantineTheme = createTheme({
  primaryColor: 'brand',
  colors: {
    brand,
  },
  fontFamily: '-apple-system, "BlinkMacSystemFont", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
  headings: {
    fontFamily: '"Josefin Sans", -apple-system, "BlinkMacSystemFont", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
  },
  defaultRadius: 'sm',
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  components: {
    Card: {
      defaultProps: {
        style: {
          backgroundColor: 'var(--color-admin-card)',
        }
      }
    },
    Table: {
      defaultProps: {
        style: {
          backgroundColor: 'var(--color-admin-card)',

        },
        styles: {
          th: {
            backgroundColor: 'var(--color-table-header)',
            color: 'var(--color-text-primary)',
            fontWeight: 600,
          },
          td: {
            padding: 'var(--spacing-table-cell)',
          },
          tr: {
            '&:hover': {
              backgroundColor: 'var(--color-table-row-hover)',
            },
            '&:nth-of-type(even)': {
              backgroundColor: 'var(--color-table-stripe)',
            }
          }
        }
      }
    },
    Button: {
      styles: (theme, params) => ({
        root: {
          '&[dataVariant="filled"]': {
            backgroundColor: 'var(--color-button-primary)',
            '&:hover': {
              backgroundColor: 'var(--color-button-primary-hover)',
            }
          },
          '&[dataVariant="outline"]': {
            // backgroundColor: 'var(--color-button-secondary)',
            // borderColor: 'var(--color-button-secondary-border)',
            color: 'var(--color-text-primary)',
            '&:hover': {
              backgroundColor: 'var(--color-admin-elevated)',
            }
          }
        }
      })
    },
    TextInput: {
      defaultProps: {
        style: {
          color: 'var(--color-text-primary)',
          borderColor: 'var(--color-input-border)',
        }
      }
    },
    Select: {
      defaultProps: {
        style: {
          borderColor: 'var(--color-input-border)',
          color: 'var(--color-text-primary)',
        }
      }
    },
    Badge: {
      styles: {
        root: {
          '&[dataVariant="filled"]': {
            '&[data-color="blue"]': {
              backgroundColor: 'var(--color-badge-info)',
            },
            '&[data-color="green"]': {
              backgroundColor: 'var(--color-badge-success)',
            },
            '&[data-color="yellow"]': {
              backgroundColor: 'var(--color-badge-warning)',
            },
            '&[data-color="red"]': {
              backgroundColor: 'var(--color-badge-danger)',
            },
            '&[data-color="gray"]': {
              backgroundColor: 'var(--color-badge-neutral)',
            }
          }
        }
      }
    }
  },
  other: {
    // Map existing CSS variables for easy access in components
    colors: {
      bg: 'var(--color-bg)',
      bgCard: 'var(--color-bg-card)',
      bgDisabledCard: 'var(--color-bg-disabled-card)',
      textPrimary: 'var(--color-text-primary)',
      textMedium: 'var(--color-text-medium)',
      textDisabled: 'var(--color-text-disabled)',
      textInverted: 'var(--color-text-inverted)',
      divider: 'var(--color-divider)',
      border: 'var(--color-border)',
      checkGreen: 'var(--color-check-green)',
      attentionRed: 'var(--color-attention-red)',
      // Admin-specific colors
      adminBg: 'var(--color-admin-bg)',
      adminCard: 'var(--color-admin-card)',
      adminElevated: 'var(--color-admin-elevated)',
      adminSidebar: 'var(--color-admin-sidebar)',
      adminSidebarHover: 'var(--color-admin-sidebar-hover)',
      adminSidebarActive: 'var(--color-admin-sidebar-active)',
      tableHeader: 'var(--color-table-header)',
      tableRowHover: 'var(--color-table-row-hover)',
      tableBorder: 'var(--color-table-border)',
      tableStripe: 'var(--color-table-stripe)',
      // buttonPrimary: 'var(--color-button-primary)',
      // buttonPrimaryHover: 'var(--color-button-primary-hover)',
      inputBg: 'var(--color-input-bg)',
      inputBorder: 'var(--color-input-border)',
      inputFocus: 'var(--color-input-focus)',
    },
    spacing: {
      page: 'var(--spacing-page)',
      section: 'var(--spacing-section)',
      card: 'var(--spacing-card)',
      tableCell: 'var(--spacing-table-cell)',
    },
    officialCellBgs: {
      apprentice: 'var(--official-cell-bg-apprentice)',
      emptyOfficial: 'var(--official-cell-bg-emptyOfficial)',
      rejectedAppointment: 'var(--official-cell-bg-rejectedAppointment)',
    },
    gameCell: {
      clash: 'var(--game-cell-color-clash)',
    },
    alerts: {
      infoBg: 'var(--color-info-bg)',
      infoText: 'var(--color-info-text)',
      warningBg: 'var(--color-warning-bg)',
      warningText: 'var(--color-warning-text)',
      dangerBg: 'var(--color-danger-bg)',
      dangerText: 'var(--color-danger-text)',
      successBg: 'var(--color-success-bg)',
      successText: 'var(--color-success-text)',
    },
  },
});
